import {MESSAGE_DATA} from '../actionTypes';
import {URLs, Messages, SubscriptionStatuses, SubscriptionHoldReason, CreditTypes} from "../../common/constants";
import {translate} from '../../i18n/translate.js';

export function setMessageData(messageData) {
    return {
        type: MESSAGE_DATA,
        messageData: messageData
    }
}

export function messageDataParser(messageData, initialData) {
    const flowType = initialData.flowType;
    const isSupportGuestMembers = initialData.staticData.isSupportGuestMembers;
    const allowUpdateVacation = initialData.staticData.allowUpdateVacation;
    const contactMessage = translate("_contactTheFarm") + " " + " (<a href=\"mailto:" + initialData.staticData.farmEmail + "\">" + initialData.staticData.farmEmail + "</a>) " +
        translate("_contactToFarm2") + "<a target='_blank' href=\"" + initialData.staticData.farmWebSiteUrl + "\">" + initialData.staticData.farmWebSiteUrl + "</a>";
    if (messageData) {
        if(initialData.staticData.isPastSeason && flowType === URLs.JOIN) {
            const customMessage = initialData.staticData.farmUrl === 'greengardens' ?
                'To sign up for the Green Box, go to <a href="https://https://www.greengardensfarm.com/boxcsa">greengardensfarm.com/boxcsa</a><br>The To Go Box was a temporary program in quick response to Covid-19.<br>' +
                'The Green Box is nearly identical with the same selections & flexibility. Questions? Email us at <a href="mailto:greenboxhelp@gmail.com">greenboxhelp@gmail.com</a>'
                : undefined;
            const body = customMessage || translate("_seasonEnded").replace("{0}", initialData.staticData.seasonTitle) + contactMessage;
            return {
                messageTitle: initialData.staticData.seasonTitle,
                messageBody: body
            }
        }
        if(messageData.status === SubscriptionStatuses.WAITLIST_SUBSCRIPTION) {
            return {
                messageTitle: Messages.WAITLIST_SUBSCRIPTION.title,
                messageBody: Messages.WAITLIST_SUBSCRIPTION.body
            }
        }
        if(messageData.status === SubscriptionStatuses.SUBSCRIPTION_EXISTS && flowType !== URLs.ACCOUNT) {
            const link = window.location.origin + "/" + URLs.ACCOUNT + "/" + initialData.staticData.farmUrl + "/" +initialData.staticData.seasonUrl;
            return {
                messageTitle: Messages.SUBSCRIPTION_EXISTS.title,
                messageBody: Messages.SUBSCRIPTION_EXISTS.body + "</br></br><a class='no-subscription-join-button' href=" + link + "><button class='button btn btn-primary'>Open My Account</button></a>"
            }
        }
        //Login to store with member without subscription
        //In case farm is set without guest user
        if (messageData.status === SubscriptionStatuses.NO_SUBSCRIPTION
             // && !isSupportGuestMembers //Show join button to all farms
        ) {
            if (flowType === URLs.ACCOUNT) {
                if (initialData.staticData.seasonRolloverEnabled) {
                    return {
                        status: SubscriptionStatuses.ROLLOVER_ENABLED,
                    }
                }
                const path = window.location.origin+ "/" + URLs.JOIN + "/" + initialData.staticData.farmUrl +  (initialData.staticData.seasonUrl? "/"+ initialData.staticData.seasonUrl:"");
                let message = translate("_noSubscription");
                if(!initialData.staticData.isPastSeason) {
                    message += "<a class='no-subscription-join-button' href=" + path + "><button class='button btn btn-primary'>" + translate("Summary_Account.join") +"</button></a>";
                }
                return {
                    messageTitle: Messages.NO_SUBSCRIPTION.title,
                    messageBody: message
                }
            }
            const link = window.location.origin + "/" + URLs.JOIN + "/" + initialData.staticData.farmUrl + "/" +initialData.staticData.seasonUrl + (!initialData.staticData.isSupportGuestMembers?'':'?mode=guest');
            return {
                messageTitle: Messages.NO_SUBSCRIPTION.title,
                messageBody: Messages.NO_SUBSCRIPTION.body + translate("Please click") + " <a href="+link+"><b>"+ translate("here") +"</b></a> " +translate("_setYourSubscription"),
            }
        }

        if (messageData.status === SubscriptionStatuses.HOLD_SUBSCRIPTION) {
            //Login with Member on permanent hold
            if (messageData.holdReason === SubscriptionHoldReason.ADMIN) {
                if(flowType === URLs.ACCOUNT) {
                    const message = initialData.staticData.accountPermanentHoldMessage ||
                        (translate("subscriptionOnHold") + "<br/>" + (initialData.staticData.allowChangePermanentHold ? 'You can reactivate it from the Delivery Hold tab.' : contactMessage));
                    return {
                        messageTitle: Messages.HOLD_SUBSCRIPTION.ADMIN.title,
                        messageBody: message
                    }
                }
                return {
                    messageTitle: Messages.HOLD_SUBSCRIPTION.ADMIN.title,
                    messageBody: Messages.HOLD_SUBSCRIPTION.ADMIN.body
                }
            }
            //Login with member on temporary hold from type new (due to signup during order delay)
            if (messageData.holdReason === SubscriptionHoldReason.NEW && flowType === URLs.STORE &&
                (!initialData.staticData.allowWebOrdersForFutureDate ||
                    (initialData.creditType === CreditTypes.CREDIT_BY_SHARE && initialData.credits === 0))) {
                return {
                    messageTitle: Messages.HOLD_SUBSCRIPTION.NEW.title,
                    messageBody: Messages.HOLD_SUBSCRIPTION.NEW.body
                }
            }
            //Login with member scheduled on hold for next delivery date
            // and farm is not set with Allow web order for future dates
            if (messageData.holdReason === SubscriptionHoldReason.VACATION) {
                if(!allowUpdateVacation) {
                    return {
                        messageTitle: Messages.HOLD_SUBSCRIPTION.VACATION.title,
                        messageBody: Messages.HOLD_SUBSCRIPTION.VACATION.body
                    }
                } else {
                    return {
                        messageTitle: Messages.HOLD_SUBSCRIPTION.VACATION_ALLOW_CHANGE.title,
                        messageBody: Messages.HOLD_SUBSCRIPTION.VACATION_ALLOW_CHANGE.body
                    }
                }

            }
        }
        //Login with Member with canceled subscription
        if (messageData.status === SubscriptionStatuses.SUBSCRIPTION_CANCELED) {
            if(flowType === URLs.ACCOUNT) {
                const message = translate("subscriptionCanceled") + "<br/>" + contactMessage;
                return {
                    messageTitle: Messages.SUBSCRIPTION_CANCELED.title,
                    messageBody: message
                }
            }
            return {
                messageTitle: Messages.SUBSCRIPTION_CANCELED.title,
                messageBody: Messages.SUBSCRIPTION_CANCELED.body
            }
        }
        //Member subscription doesn’t have next delivery date as
        // the schedule doesn’t have defined future dates.
        if (messageData.status === SubscriptionStatuses.NO_FUTURE_DELIVERIES) {
            return {
                messageTitle: Messages.NO_FUTURE_DELIVERIES.title,
                messageBody:  Messages.NO_FUTURE_DELIVERIES.body
            }
        }
        //Subscription canceled but in wait list
        if (messageData.status === SubscriptionStatuses.STORE_WAITLIST_SUBSCRIPTION) {
            return {
                messageTitle: Messages.STORE_WAITLIST_SUBSCRIPTION.title,
                messageBody: Messages.STORE_WAITLIST_SUBSCRIPTION.body
            }
        }
        // Load webstore when payment is processing
        // The WebOrder.state=INCOMPLETE
        if (messageData.status === SubscriptionStatuses.PROCESSING_ORDER || messageData.status === SubscriptionStatuses.PROCESSING_SUBSCRIPTION) {
            return {
                messageTitle: Messages.PROCESSING_ORDER.title,
                messageBody: Messages.PROCESSING_ORDER.body
            }
        }
        // Store is closed ­ Based on store open close hours
        if (messageData.status === SubscriptionStatuses.STORE_CLOSED) {
            if(!initialData.staticData.isMultipleActiveOrdersEnabled) {
                let body = messageData.openingHours ? translate("storeClosed").replace("{0}", messageData.openingHours) :
                    translate("storeClosedNoHours");
                if (initialData.staticData.storeCloseAdditionalMessage) {
                    body += '<br/>' + initialData.staticData.storeCloseAdditionalMessage;
                }
                return {
                    messageTitle: Messages.STORE_CLOSED.title,
                    messageBody: body
                }
            } else {
                return {isStoreClosedWithMultiOrders:true}
            }
        }
        else {
            return {};
        }
    }
}

export function getStoreCloseMessage(storeData, storeCloseAdditionalMessage){
    if (storeData.status === SubscriptionStatuses.STORE_CLOSED) {
        let body = storeData.openingHours? 'Sorry, the web store is closed but will reopen for you to place your order from '
            + storeData.openingHours + '.':'Sorry, the web store is closed.';
        if (storeCloseAdditionalMessage) {
            body += '<br/>' + storeCloseAdditionalMessage;
        }
        return {
            messageTitle: 'Store Closed',
            messageBody:body
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/common/messagePageActions.js